/*=========================================================================================
  File Name: moduleAdminState.js
  Description: Admin Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
    adminUser: [],
    count: "",
    adminStatus: [],
    blockedReason: [],
    adminRoleOptions: [],
    loginAdminInfo: ''
}